<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      title="翻译查询"
      width="80%"
      @close="handleClose"
    >
      <div class="search-container">
        <el-input
          v-model="searchText"
          placeholder="请输入关键词搜索（支持key、中文、越南文）"
          clearable
          style="width: 600px; margin-bottom: 20px"
          @input="handleSearch"
        >
        </el-input>
      </div>

      <!-- 限制高度 -->
      <el-table :data="filteredData" height="450" style="width: 100%;" border stripe>
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ getSerialNumber(scope.row.zh) }}
          </template>
        </el-table-column>
        <el-table-column prop="key" label="Key" min-width="200">
          <template slot-scope="scope">
            <div style="cursor: pointer;" @click="copyToClipboard(scope.row.key)">{{
              scope.row.key
            }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="zh" label="中文" min-width="200">
          <template slot-scope="scope">
            <div style="cursor: pointer;" @click="copyToClipboard(scope.row.zh)">{{
              scope.row.zh
            }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="vn" label="越南文" min-width="200">
          <template slot-scope="scope">
            <div style="cursor: pointer;" @click="copyToClipboard(scope.row.vn)">{{
              scope.row.vn
            }}</div>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="dialog-footer">
        <el-pagination
          background
          layout="prev, pager, next, jumper, total"
          :total="filteredAllData.length"
          :page-size="pageSize"
          v-model="currentPage"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入中文和越南文语言包
import zhMessages from "../lang/messages/zh.js";
import vnMessages from "../lang/messages/vn.js";

export default {
  name: "I18nKeyMap",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      searchText: "",
      allData: [],
      currentPage: 1,
      pageSize: 20,
    };
  },
  computed: {
    // 过滤后的所有数据
    filteredAllData() {
      let data = this.allData;

      // 根据搜索文本过滤数据
      if (this.searchText) {
        const searchLower = this.searchText.toLowerCase();
        data = data.filter(
          (item) =>
            item.key.toLowerCase().includes(searchLower) ||
            item.zh.toLowerCase().includes(searchLower) ||
            item.vn.toLowerCase().includes(searchLower)
        );
      }

      return data;
    },
    // 当前页显示的数据
    filteredData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.filteredAllData.slice(start, end);
    },
  },
  watch: {
    visible: {
      handler(newVal) {
        this.dialogVisible = newVal;
        if (newVal) {
          this.loadI18nData();
        }
      },
      immediate: true,
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.$emit("update:visible", false);
      }
    },
  },
  methods: {
    // 加载i18n数据
    loadI18nData() {
      this.allData = [];

      // 递归遍历对象获取所有key和值
      this.traverseObject(zhMessages, vnMessages, "root", this.allData);

      console.log("I18n数据加载完成，共", this.allData.length, "条记录");
    },

    // 递归遍历对象
    traverseObject(zhObj, vnObj, parentKey, result) {
      Object.keys(zhObj).forEach((key) => {
        const currentKey = parentKey === "root" ? key : `${parentKey}.${key}`;

        if (typeof zhObj[key] === "object" && zhObj[key] !== null) {
          // 如果是对象，继续递归
          this.traverseObject(zhObj[key], vnObj[key] || {}, currentKey, result);
        } else {
          // 如果是叶子节点，添加到结果数组
          result.push({
            key: currentKey,
            zh: zhObj[key] || "",
            vn: (vnObj && vnObj[key]) || "",
          });
        }
      });

      // 处理越南文中存在但中文中不存在的key
      if (vnObj) {
        Object.keys(vnObj).forEach((key) => {
          const currentKey = parentKey === "root" ? key : `${parentKey}.${key}`;

          // 检查是否已经存在
          const exists = result.some((item) => item.key === currentKey);
          if (!exists && typeof vnObj[key] !== "object") {
            result.push({
              key: currentKey,
              zh: "",
              vn: vnObj[key] || "",
            });
          }
        });
      }
    },

    // 搜索处理
    handleSearch() {
      this.currentPage = 1; // 搜索时重置到第一页
    },

    // 分页变化处理
    handleCurrentChange(val) {
      this.currentPage = val;
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.searchText = "";
      this.currentPage = 1;
    },

    // 从翻译文本中提取序号
    getSerialNumber(text) {
      if (!text) return '';
      
      // 按空格分割文本
      const parts = text.split(' ');
      if (parts.length > 0) {
        const firstPart = parts[0];
        // 判断第一个部分是否为纯数字
        if (/^\d+$/.test(firstPart)) {
          return firstPart;
        }
      }
      
      return '';
    },

    // 复制到剪贴板
    copyToClipboard(text) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);

      this.$message({
        message: "已复制到剪贴板",
        type: "success",
        duration: 2000,
      });
    },
  },
};
</script>

<style scoped>
.search-container {
  margin-bottom: 20px;
}

.dialog-footer {
  text-align: center;
  padding: 10px 0;
}

.el-tag {
  cursor: pointer;
  user-select: text;
}

.el-tag:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}
</style>
